/*
//import LinkOption from "./LinkService.vue";
import Ncf from "./NcfLinkService.vue";
import mpago from "./MagypagoLinkService.vue";
import fide from "./FidelizacionLinkService.vue";
import CustomerLink from "./CustomerLink.vue";
import TerminalLink from "./TerminalesLink.vue";
import CustomerACT from "./CustomerACT.vue";
import CustomerINA from "./CustomerINA.vue";
*/
import hyperlinkNFC from "@/components/functionals/HyperlinkForNfcMovilReports.vue";
import hyperlinkNFCTotalConsumos from "@/components/functionals/HyperlinkForNfcMovilTotalConsumos.vue";
import hyperlinkPP from "@/components/functionals/HyperlinkPagoProveedores.vue";
import hyperlinkNFCRecargas from "@/components/functionals/HyperlinkForNfcMovilTotalRecargasReport.vue";
import HyperlinkForCxC_DiferenceDetail from "@/components/functionals/HyperlinkForCxC_DiferenceDetail.vue";
import { formatMonto } from "@/utils";
//import { formatDate } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import HyperlinkCliente from "@/components/functionals/HyperLinkForDataCliente.vue";
export const Columns = [
  {
    prop: "clientid",
    label: "Codigo Cliente",
    width: 150,
    align: "center",
    sortable: true,
    fixed: true
  },
  {
    prop: "RNC_Cliente",
    label: "RNC Cliente",
    width: 130,
    align: "center",
    sortable: true,
    fixed: true
  },
  {
    prop: "clientName",
    label: "Nombre de Clientes",
    width: 300,
    sortable: true,
    fixed: true,
    formatter: hyperlinkNFC
  },
  {
    prop: "cardQty",
    label: "Cantidad de Tarjetas",
    width: 180,
    align: "center",
    sortable: true
    //fixed: false
    //formatter: Ncf
  },
  {
    prop: "limite_credito",
    label: "Limite de Credito",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    formatter: (row) => formatMonto(row.limite_credito)
    //formatter: hyperlinkPP
  },
  {
    prop: "totalRecharges",
    label: "Total de Recargas",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    //formatter: row => formatMonto(row.totalRecharges)
    fixed: false,
    //formatter: row => formatMonto(row.totalRecharges)
    formatter: hyperlinkNFCRecargas
    //formatter: row => hyperlinkNFCRecargas(ColorType(row.totalRecharges))
  },

  {
    prop: "totalConsumption",
    label: "Total de Cosumos",
    width: 180,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: hyperlinkNFCTotalConsumos
    // formatter: row => formatMonto(row.totalConsumption)
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    //formatter: row => formatMonto(row.totalConsumption)
  },
  {
    prop: "calculatedBalance",
    label: "Balance Calculado disponible",
    width: 250,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.calculatedBalance)
  },
  {
    prop: "dbBalance",
    label: "Balance disponible en BD",
    width: 210,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.dbBalance)
  },
  {
    prop: "balanceDiff",
    label: "Diferencia de Balance",
    width: 190,
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.balanceDiff)
  },
  // {
  //   prop: "",
  //   label: "",
  //   width: 5
  //   //sortable: true,
  //   //fixed: false,
  //   //formatter: row => ""
  //   //formatter: row => formatMonto(row.balanceDiff)
  // },
  {
    prop: "ToTal_ClientPayment",
    label: "Pagos a los proveedores",
    width: 210,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    //formatter: row => formatMonto(row.ToTal_ClientPayment)
    formatter: hyperlinkPP
  },
  {
    prop: "totalPrepaidRecharges",
    label: "Recargas Prepagos",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    formatter: (row) => formatMonto(row.totalPrepaidRecharges)
    //formatter: hyperlinkPP
  },
  {
    prop: "Client_CxPtoSupplier",
    label: "C x P calculada",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.Client_CxPtoSupplier)
  },

  {
    prop: "ToTal_CxP_BD",
    label: "CXP registrada en BD",
    width: 190,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: (row) => formatMonto(row.ToTal_CxP_BD)
  },
  {
    prop: "CxP_Diff",
    label: "Diferecncia en CxPs",
    width: 180,
    align: "center",
    sortable: true,
    formatter: HyperlinkForCxC_DiferenceDetail //ColorType
    //fixed: false,
    //formatter: row => formatMonto((row.Diff = 0.0))
  }

  /*
  {
    prop: "TerminalQty",
    label: "Terminales",
    width: 80,
    sortable: true,
    //fixed: false,
    //formatter: TerminalLink
  }
  */
];
/*
export const supplierBalanceMockupData = [
  {
    code: "001",
    clientName: "Cliente 1",
    cardQty: 50,
    totalRecharges: 153000.0,
    totalConsumption: 45800.0,
    calculatedBalance: 107200.0,
    dbBalance: 107200.0,
    balanceDiff: 0
  },
  {
    code: "002",
    clientName: "Cliente 2",
    cardQty: 60,
    totalRecharges: 1487744888.0,
    totalConsumption: 4574.0,
    calculatedBalance: 1487740314.0,
    dbBalance: 1487740314.0,
    balanceDiff: 0
  },
  {
    code: "003",
    clientName: "Cliente 3",
    cardQty: 70,
    totalRecharges: 15487.0,
    totalConsumption: 4589.0,
    calculatedBalance: 10898.0,
    dbBalance: 8000.0,
    balanceDiff: 2898.0
  }
];
*/
export const ClientsBalanceDetailledColumns = [
  {
    prop: "cardId",
    label: "Tarjeta",
    width: 100,
    align: "center",
    sortable: true,
    fixed: true
  },
  {
    prop: "cardHolderName",
    label: "Tarjeta Habiente",
    width: 170,
    sortable: true
    //fixed: false
    //formatter: hyperlinkNFC
  },
  /*
  {
    prop: "cardTypeT",
    label: "Tipo de Tarjetas Tabla Tarjetas",
    width: 80,
    align: "center",
    sortable: true,
    //fixed: false
    //formatter: Ncf
  },
  */
  /*{
    prop: "cardTypeTE",
    label: "Tipo de Tarjetas",
    width: 100,
    align: "center",
    sortable: true
    //fixed: false
    //formatter: Ncf
  },*/

  {
    prop: "tipoTarjeta",
    label: "Tarjeta Tipo",
    width: 100,
    align: "center",
    sortable: true
    //fixed: false
    //formatter: Ncf
  },

  {
    prop: "tipodeControl",
    label: "Tipo de control",
    width: 125,
    align: "center",
    sortable: true
    //fixed: false
    //formatter: Ncf
  },
  /*
  {
    prop: "cardQty",
    label: "Cantidad de Tarjetas",
    width: 80,
    align: "center",
    sortable: true,
    //fixed: false
    //formatter: Ncf
  },
  */
  {
    prop: "totalRecharges",
    label: "Total de Recargas",
    width: 110,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.totalRecharges)
  },
  {
    prop: "totalConsumption",
    label: "Total de Cosumos",
    width: 110,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.totalConsumption)
  },
  {
    prop: "calculatedBalance",
    label: "Balance Calculado",
    width: 110,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.calculatedBalance)
  },
  /*{
    prop: "dbBalance",
    label: "Balance en BD",
    width: 110,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.dbBalance)
  },*/

  {
    prop: "dbBalances",
    label: "Balance en BD",
    width: 110,
    align: "center",
    sortable: true
    //fixed: false,
    //formatter: ColorType
    //formatter: row => formatMonto(row.dbBalance)
  },
  {
    prop: "balanceDiff",
    label: "Diferencia de Balance",
    width: 130,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.balanceDiff)
  }

  /*
  {
    prop: "TerminalQty",
    label: "Terminales",
    width: 100,
    sortable: true,
    //fixed: false,
    //formatter: TerminalLink
  }
  */
];

export const BalanceReportActions = [
  {
    icon: "el-icon-s-data",
    label: "Actualizar balance en Base de Datos",
    command: "update-balance-command"
  },
  {
    icon: "el-icon-s-data",
    label: "Actualizar CxP en Base de Datos",
    command: "update-CxC-command"
  }
];

export const ClientsBalanceDetailledActions = [
  {
    icon: "el-icon-s-data",
    label: "Actualizar balance",
    command: "update-balance-command"
  }
];

//CONST DE REPORTE TOTAL DE RECARGAS

export const RecargaTotalReportDetailledColumns = [
  {
    prop: "fecha",
    label: "Fecha y Hora",
    minWidth: 170,
    sortable: true,
    fixed: false,
    formatter:
      DatetimeFormatter /*row => formatDate(row.fecha, "DD/MM/YYYY hh:mm:ss")*/
  },
  {
    prop: "Tipo",
    label: "Tipo",
    minWidth: 170,
    sortable: true,
    fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "concepto",
    label: "Descripcion Recarga",
    minWidth: 170,
    sortable: true,
    fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "monto",
    label: "Montos",
    width: 170,
    sortable: true,
    fixed: false,
    formatter: (row) => formatMonto(row.monto)
  },
  /*{
    prop: "tarjetaid",
    label: "Tarjeta",
    minWidth: 100,
    align: "center",
    sortable: true,
    fixed: true
  },*/

  {
    prop: "status",
    label: "Status",
    width: 170,
    sortable: true,
    fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "Proveedor",
    label: "Nombre Proveedor",
    minWidth: 120,
    align: "center",
    sortable: true,
    fixed: false
  }
];

export const ColumnsCompanyBalanceTable = [
  {
    prop: "empresaid",
    label: "Codigo Empresa",
    width: 150,
    align: "center",
    sortable: true,
    fixed: true
    //formatter: HyperlinkCliente
  },
  {
    prop: "RNC_Empresa",
    label: "RNC Empresa",
    width: 130,
    align: "center",
    sortable: true,
    fixed: true
  },
  {
    prop: "nombre",
    label: "Nombre Empresa",
    width: 300,
    sortable: true,
    fixed: true,
    formatter: HyperlinkCliente
  },
  {
    prop: "CantidadTarjeta",
    label: "Cantidad de Tarjetas",
    width: 180,
    align: "center",
    sortable: true
    //fixed: false
    //formatter: Ncf
  },
  {
    prop: "totalRecharges",
    label: "Total de Recargas",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    //formatter: row => formatMonto(row.totalRecharges)
    fixed: false
    //formatter: row => formatMonto(row.totalRecharges)
    //formatter: hyperlinkNFCRecargas
    //formatter: row => hyperlinkNFCRecargas(ColorType(row.totalRecharges))
  },

  {
    prop: "totalConsumption",
    label: "Total de Consumos",
    width: 180,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: hyperlinkNFCTotalConsumos
    // formatter: row => formatMonto(row.totalConsumption)
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    //formatter: row => formatMonto(row.totalConsumption)
  },
  {
    prop: "calculatedBalance",
    label: "Balance Calculado disponible",
    width: 250,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.calculatedBalance)
  },
  {
    prop: "dbBalance",
    label: "Balance disponible en BD",
    width: 210,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.dbBalance)
  },
  {
    prop: "balanceDiff",
    label: "Diferencia de Balance",
    width: 190,
    sortable: true,
    //fixed: false,
    formatter: ColorType
    //formatter: row => formatMonto(row.balanceDiff)
  },
  // {
  //   prop: "",
  //   label: "",
  //   width: 5
  //   //sortable: true,
  //   //fixed: false,
  //   //formatter: row => ""
  //   //formatter: row => formatMonto(row.balanceDiff)
  // },
  {
    prop: "ToTal_ClientPayment",
    label: "Cobro a los clientes",
    width: 210,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    //formatter: row => formatMonto(row.ToTal_ClientPayment)
    formatter: hyperlinkPP
  },
  {
    prop: "totalPrepaidRecharges",
    label: "Recargas Prepagos",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    formatter: (row) => formatMonto(row.totalPrepaidRecharges)
    //formatter: hyperlinkPP
  },
  {
    prop: "totalCreditRecharges",
    label: "Recargas A Credito",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType //mine to check and fix
    formatter: (row) => formatMonto(row.totalCreditRecharges)
    //formatter: hyperlinkPP
  },
  {
    prop: "CXC_Clientes",
    label: "CXC_Clientes",
    width: 180,
    align: "center",
    sortable: true,
    //fixed: false,
    //formatter: ColorType
    formatter: (row) => formatMonto(row.CXC_Clientes)
  }
];
